module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAPCAYAAAD+pA/bAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADISURBVDiNtZM9DsIwDIWfo56iPR1CHTp2hqEDDEhIjAwIcTpyCYrNkBKcVP0B0m9p/Oq8Z7UJAYDcSJAQWgn5tVzTmnvjtQvJ8FRqycDF9OuS+w5juiMHYDO0UcNQfVbBFTv9rVUcvlf0A6poqjZ6Tg0yGXBSk9ScIOARKUN1zfP6Ikh2ZplTtOUCgCUAkCZtCDVcdEtLSs91k2zMPdi095vmYgEgiwWP+ml0+Ez0ZUgQENJdQDr+bj6K1EbgPls+1fsPi5on4QUlYkfw/Z9poQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ../assets/images/hot.png
// module id = 2171
// module chunks = 0